import type { Hit } from 'instantsearch.js'
import { t } from '../../../../assets/utils/algolia/algoliaLocalization'
import { createGoogleMapsUrl } from '../../../../assets/utils/format'
import { useConfigContext } from './ConfigContext'
import { _x } from '@wordpress/i18n'
import useReplaceImgixUrl from '../../../../assets/utils/useReplaceImgixUrl'

function ServiceLocationCard(props: {
  hit: Hit
}) {
  const { hit } = props

  const { locationsPageUrl } = useConfigContext()

  const { imgixSrcUrl, imgixTargetUrl } = useConfigContext()
  const replaceImgixUrl = useReplaceImgixUrl(imgixSrcUrl, imgixTargetUrl)

  const placeName = t(hit?.place?.name, { fallback: 'any' })
  const additional = t(hit?.place?.additional, { fallback: 'any' })
  const street = t(hit?.place?.street, { fallback: 'any' })
  const postalCode = t(hit?.place?.postalCode, { fallback: 'any' })
  const city = t(hit?.place?.city, { fallback: 'any' })
  const country = t(hit?.place?.country, { fallback: 'any' })
  const geolocation = hit?.place?.geolocation
  const mapsUrl = hit?.place?.mapsUrl

  const displayBody =
    placeName || street || postalCode || city || country || geolocation

  const cityWithPostalCode = `${postalCode || ''}${city ? ` ${city}` : ''}`

  return (
    <div className="services-location-card card" data-bs-theme="dark">
      {displayBody && (
        <div className="card-body">
          <div>
            <h3 className="h2">{placeName}</h3>
            <address className="mb-0">
              {additional && (
                <>
                  {additional}
                  <br />
                </>
              )}
              {street}
              {cityWithPostalCode && (
                <>
                  <br />
                  {cityWithPostalCode}
                </>
              )}
              {country && (
                <>
                  <br />
                  {country}
                </>
              )}
            </address>
            <div className="d-flex mt-4 mt-lg-3 gap-2 row-gap-1 flex-wrap justify-content-center justify-content-lg-start">
              <a
                href={createGoogleMapsUrl(geolocation, mapsUrl)}
                className="btn btn-sm btn-dark-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>
                  {_x('Plan route', 'Celebration Plan Route Button', 'icf')}
                </span>
                <i className="icon fa-map" aria-hidden="true" />
              </a>
              <a href={locationsPageUrl} target='_blank' className="btn btn-sm btn-dark-1">
                {_x(
                  'More locations',
                  'Celebration More Locations Button',
                  'icf'
                )}
              </a>
            </div>
          </div>
        </div>
      )}
      <div className="image-container">
        <img
          src={replaceImgixUrl(t(hit?.place?.image?.url, { fallback: 'any' }), {
            ratio: '1.4:1',
            width: 700
          })}
          alt={t(hit?.place?.image?.altText, { fallback: 'any' })}
          title={t(hit?.place?.image?.title, { fallback: 'any' })}
        />
      </div>
    </div>
  )
}

export default ServiceLocationCard
